/* eslint-disable no-console */
/* eslint-disable react/no-unused-prop-types */
import { FC } from 'react';
import { IconButton } from '@components/design-system';
import * as Styles from './styles';

interface ICircleButtonAdd {
  label: string;
  onClick?: () => void;
}

export const CircleButtonAdd: FC<ICircleButtonAdd> = ({ label, onClick = () => null }) => {
  return (
    <Styles.Label onPointerUp={onClick}>
      <IconButton>
        <i>add</i>
      </IconButton>
      {label}
    </Styles.Label>
  );
};
